export const ItemTypes = {
  PLAYER: 'player',
};

export enum PlayerEnum {
  ONE,
  TWO,
  THREE,
  FOUR,
}
